export const SET_DAYS_FILTER_TEMPLATES_ID = 'SET_DAYS_FILTER_TEMPLATES_ID'
